import React, { FC, ReactNode } from 'react';

import styles from './PdpCarDetail.module.scss';

interface PdpCarDetailProps {
  Icon?: ReactNode;
  title: ReactNode;
  value: ReactNode;
}

export const PdpCarDetail: FC<PdpCarDetailProps> = ({ Icon, title, value }) => (
  <div className={styles.root}>
    <dt className={styles.leftContainer}>
      {Icon}
      <p className={styles.title}>{title}</p>
    </dt>
    <dd className={styles.value} data-testid={`CarSummary-component-${title}-info`}>
      {value}
    </dd>
  </div>
);
